import { render } from "./SimpleHeader.vue?vue&type=template&id=2adef164&scoped=true&bindings={\"name\":\"props\",\"back\":\"props\",\"noback\":\"props\",\"goBack\":\"setup\",\"isback\":\"setup\"}"
import script from "./SimpleHeader.vue?vue&type=script&lang=js"
export * from "./SimpleHeader.vue?vue&type=script&lang=js"

import "./SimpleHeader.vue?vue&type=style&index=0&id=2adef164&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2adef164"

export default script